/**
 * A function to check if the "window" object is
 * defined
 * 
 * @returns a boolean result
 */
export default () => typeof window !== "undefined"
